import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import * as React from 'react'

import isomorphicApolloClient, { CreateApolloClientProps } from './isomorphic-apollo-client'
import apiServerApolloClientCache from './api-server-apollo-client-cache'
import apiServerLink from './api-server-link'

function createApiServerApolloClient({
  isServer,
}: CreateApolloClientProps): ApolloClient<NormalizedCacheObject> {
  console.log('createApiServerApolloClient', { isServer })
  const client = new ApolloClient({
    ssrMode: isServer,
    link: apiServerLink(),
    cache: apiServerApolloClientCache(),
    connectToDevTools: false,
  })

  return client
}

const apiServerApolloClient = isomorphicApolloClient(createApiServerApolloClient)

export function useApiServerApolloClient(
  initialState: NormalizedCacheObject | null = {},
): ApolloClient<NormalizedCacheObject> {
  const apolloClient = React.useMemo(() => apiServerApolloClient(initialState), [initialState])

  return apolloClient
}

export default apiServerApolloClient
